/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showSuccessSnackbar } from "../Action/snackbarAction";
import { showErrorSnackbar } from "../Action/snackbarAction";
import { optionTypeImage, optionTypeText } from "../Utils/dataConstants";
import { image_size_150, validateIsFileImageType } from "../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../Utils/errorMsg";
import { uploadQuestionImage } from "../Action/courseAction";
import ImagePickerAndViewer from "../Component/imagePickerAndViewer";
import TextEditor from "../Screen/DataEntryPanel/CreateQuestion/textEditor";
const emptyOption = {
  descType: "",
  description: "",
  isCorrect: false,
};
function OptionMCQ(props) {
  const dispatch = useDispatch();
  const { index, setOptionData, option, labelName, maxLength, isSetWordCount } =
    props;
  const [isCorrect, setIsCorrect] = useState(false);
  const [description, setDesctiption] = useState("");
  const [desctiptionType, setDesctiptionType] = useState("");
  const [optionImage, setOptionImage] = useState("");
  const [options, setOptions] = useState(emptyOption);
  useEffect(() => {
    if (!option) {
      setDesctiption("");
      setOptionImage("");
      setIsCorrect(false);
      setDesctiptionType("");
      setOptions(emptyOption);
      return;
    }

    const { descType = "", description = "", isCorrect = false } = option;
    const data = String(description || "");
    const removeData = data.replace(/\\n/g, " ");
    const modifiedHtml = removeData.replace(/\\t/g, " ");
    setDesctiption(modifiedHtml);
    setOptionImage(description);
    setIsCorrect(isCorrect);
    setDesctiptionType(descType);
    setOptions(option);
  }, [option]);
  const showMenu = (type) => {
    if (type === "text") {
      setOptionImage("");
      setDesctiptionType("text");
    } else {
      setDesctiption("");
      setDesctiptionType("img");
    }
  };
  // const showMenu = (obj) => {
  //   if (obj === "text") {
  //     setOptionImage("");
  //     // setOptions(optionTypeText);
  //     setDesctiptionType("text");
  //   } else {
  //     setDesctiption("");
  //     // setOptions(optionTypeImage);
  //     setDesctiptionType("img");
  //   }
  // };

  const onChangeRadio = (val) => {
    setIsCorrect(val);
    if (desctiptionType === "text") {
      setOptionsValue(description, val);
    } else {
      setOptionsValue(optionImage, val);
    }
  };

  const onChangeText = (val) => {
    setDesctiption(val);
    setOptionsValue(val, isCorrect);
  };

  const setOptionsValue = (val, radioval) => {
    const PostData = {
      descType: desctiptionType,
      description: val,
      isCorrect: radioval,
      index: index,
    };
    setOptionData(PostData);
    return PostData;
  };

  const handleOptionImageChange = (e) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > image_size_150) {
      dispatch(showErrorSnackbar("File size should be less than 150 KB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        setOptionImage(reader.result);
      };
      reader.readAsDataURL(file);

      dispatch(
        uploadQuestionImage(
          file,
          (res) => {
            if (res?.media) {
              dispatch(showSuccessSnackbar("File Succesfully Uploaded"));
              setOptionsValue(res?.media, isCorrect);
            } else {
              dispatch(showErrorSnackbar("File Not Uploaded"));
            }
          },
          () => {},
        ),
      );
    }
  };

  return (
    <div className="border border-bottom-1 p-2 rounded-2 mb-2">
      <div className="CreateQuestionTitle d-flex justify-content-between mt-0 rounded-top">
        <h5 className="admitCardHeading text-left d-flex ">
          Option {index + 1}
        </h5>
        <div className="correctOption-check d-flex align-items-center p-2">
          <span className="me-3" style={{ color: "var(--purple)" }}>
            Correct Option
          </span>
          <input
            type="radio"
            label="Correct option"
            name={labelName ? labelName : "correct"}
            checked={isCorrect}
            onChange={(value) => onChangeRadio(value.target.checked)}
          />
        </div>
        <div className=" d-flex">
          <div
            className="cursor addInputbtn ms-2 p-1"
            onClick={() => showMenu("text")}
          >
            + Text
          </div>
          {!props?.noImage && (
            <div
              className="cursor addInputbtn ms-2 p-1"
              onClick={() => showMenu("img")}
            >
              + Image
            </div>
          )}
        </div>
      </div>
      <div className="col-auto">
        {desctiptionType === "text" && (
          <div className="editor_content mb-2">
            <TextEditor
              setInputText={(value) => onChangeText(value)}
              value={description}
              isSetWordCount={isSetWordCount}
              maxLength={maxLength}
            />
          </div>
        )}

        {desctiptionType === "img" && (
          <div className="mb-2">
            <ImagePickerAndViewer
              labelName={"Option Image"}
              value={optionImage}
              handleChange={(e) => handleOptionImageChange(e, index)}
              htmlFor={`mcq-photo-upload ${index}`}
              Isrequired={true}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default OptionMCQ;
